import { isPlausibleUsername } from "./plausibleUsername";

export { isPlausibleUsername };

export const MAX_TOAST_SIGNUPS = 3;
export const MAX_SIGNUP_AGE_MS = 48 * 60 * 60 * 1000;
const HOUR_MS = 60 * 60 * 1000;
// Recency is judged against the visitor's clock, so a browser running behind
// the server would otherwise discard the newest signups as future-dated.
const CLOCK_SKEW_TOLERANCE_MS = 5 * 60 * 1000;

function joinedTimestamp(signup) {
  const joinedMs = new Date(signup?.joinedAt).getTime();
  return Number.isFinite(joinedMs) ? joinedMs : null;
}

export function isRecentEnoughSignup(joinedAt, now = Date.now()) {
  const joinedMs = new Date(joinedAt).getTime();
  if (!Number.isFinite(joinedMs)) return false;
  const nowMs = now instanceof Date ? now.getTime() : Number(now);
  if (!Number.isFinite(nowMs)) return false;
  const ageMs = nowMs - joinedMs;
  return ageMs >= -CLOCK_SKEW_TOLERANCE_MS && ageMs <= MAX_SIGNUP_AGE_MS;
}

export function formatSignupRecency(joinedAt, now = Date.now()) {
  const joinedMs = new Date(joinedAt).getTime();
  if (!Number.isFinite(joinedMs)) return null;
  const nowMs = now instanceof Date ? now.getTime() : Number(now);
  if (!Number.isFinite(nowMs)) return null;
  const ageMs = Math.max(0, nowMs - joinedMs);
  const hours = Math.floor(ageMs / HOUR_MS);
  if (hours < 1) return "just now";
  return `${hours}h ago`;
}

export function selectQualifyingSignups(
  signups,
  { now = Date.now(), limit = MAX_TOAST_SIGNUPS } = {}
) {
  if (!Array.isArray(signups) || signups.length === 0) return [];

  return signups
    .filter((signup) => {
      if (!signup?.signupKey || !signup?.joinedAt) return false;
      if (!isRecentEnoughSignup(signup.joinedAt, now)) return false;
      return isPlausibleUsername(signup.nickname);
    })
    .sort((a, b) => joinedTimestamp(b) - joinedTimestamp(a))
    .slice(0, Math.max(0, limit));
}
